import {
  EuiButton,
  EuiButtonEmpty,
  EuiCallOut,
  EuiFieldText,
  EuiForm,
  EuiFormRow,
  EuiModal,
  EuiModalBody,
  EuiModalFooter,
  EuiModalHeader,
  EuiModalHeaderTitle,
  EuiTextArea,
} from '@elastic/eui';
import axios from 'axios';
import type { ChangeEvent } from 'react';
import { useState } from 'react';

import type { AsyncData } from '../model';

export interface ContactFormModalProps {
  onClose: () => void;
}

export function ContactFormModal({ onClose }: ContactFormModalProps) {
  const [message, setMessage] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [sendingStatus, setSendingStatus] = useState<AsyncData<null> | null>(null);

  const sendingStatusCallout =
    sendingStatus?.status === 'succeeded' ? (
      <EuiFormRow>
        <EuiCallOut size="s" title="Your message has been successfully sent." color="success" iconType="check" />
      </EuiFormRow>
    ) : sendingStatus?.status === 'failed' ? (
      <EuiFormRow>
        <EuiCallOut size="s" title="An error occurred, please try again later" color="danger" iconType="alert" />
      </EuiFormRow>
    ) : undefined;

  return (
    <EuiModal onClose={onClose}>
      <EuiModalHeader>
        <EuiModalHeaderTitle>Contact Us</EuiModalHeaderTitle>
      </EuiModalHeader>
      <EuiModalBody>
        <EuiForm id="contact-form" component="form">
          {sendingStatusCallout}
          <EuiFormRow label="Message">
            <EuiTextArea
              placeholder="Include any question, suggestion, feedback you would like to share or email us directly to contact@etfvue.com."
              value={message}
              onChange={(e: ChangeEvent<HTMLTextAreaElement>) => {
                setMessage(e.target.value);
              }}
            />
          </EuiFormRow>
          <EuiFormRow label="Your email">
            <EuiFieldText
              required
              value={email}
              type={'email'}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                setEmail(e.target.value);
              }}
            />
          </EuiFormRow>
        </EuiForm>
      </EuiModalBody>
      <EuiModalFooter>
        <EuiButtonEmpty onClick={onClose}>Cancel</EuiButtonEmpty>
        <EuiButton
          type="submit"
          form="contact-form"
          fill
          onClick={(e) => {
            e.preventDefault();

            if (sendingStatus?.status === 'pending') {
              return;
            }

            setSendingStatus({ status: 'pending' });
            axios.post('/api/send_message', email ? { message, email } : { message }).then(
              () => {
                setSendingStatus({ status: 'succeeded', data: null });
                setMessage('');
                setEmail('');
              },
              (err) => {
                setSendingStatus({ status: 'failed', error: err });
              },
            );
          }}
          isLoading={sendingStatus?.status === 'pending'}
          isDisabled={message.trim().length === 0 || email.trim().length === 0}
        >
          Send
        </EuiButton>
      </EuiModalFooter>
    </EuiModal>
  );
}
